// extracted by mini-css-extract-plugin
module.exports = {"modal":"DeleteConfirmation_modal__2iiNR","modalButtons":"DeleteConfirmation_modalButtons__2dz0C","button":"DeleteConfirmation_button__10l5t"};